import React, { createContext, useContext, useState, useRef } from "react";

const AudioContext = createContext();

export const useAudio = () => {
    const context = useContext(AudioContext);
    if (!context) {
        throw new Error("useAudio must be used within an AudioProvider");
    }
    return context;
};

export const AudioProvider = ({ children }) => {
    const [stream, setStream] = useState(null);
    const [isRecording, setIsRecording] = useState(false);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);

    const startAudioContext = (mediaStream) => {
        if (!audioContextRef.current) {
            audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        }

        const source = audioContextRef.current.createMediaStreamSource(mediaStream);
        analyserRef.current = audioContextRef.current.createAnalyser();
        analyserRef.current.fftSize = 256;

        source.connect(analyserRef.current);

        setStream(mediaStream);
    };

    const stopAudioContext = () => {
        if (stream) {
            stream.getTracks().forEach((track) => track.stop());
        }
        setStream(null);
        if (audioContextRef.current && audioContextRef.current.state !== "closed") {
            audioContextRef.current.close();
            audioContextRef.current = null;
        }
        analyserRef.current = null;
    };

    const value = {
        stream,
        isRecording,
        setIsRecording,
        analyser: analyserRef.current,
        audioContext: audioContextRef.current,
        startAudioContext,
        stopAudioContext,
    };

    return <AudioContext.Provider value={value}>{children}</AudioContext.Provider>;
};
